import styled from 'styled-components';

const TitleListSubscribers = styled.div`
	color: ${({ theme }) => theme.colorTitleListSubscribers};

	h3 {
		font-size: ${({ theme }) => theme.fontSizeTitleListSubscribers};
		color: ${({ theme }) => theme.colorTitleListSubscribers};
		font-family: ${({ theme }) => theme.fontFamilyTitleListSubscribers};
		font-weight: ${({ theme }) => theme.fontWeightTitleListSubscribers};
		margin-top: 0;
	}
`;

export default TitleListSubscribers;
